import { useMatchRoute } from "@tanstack/react-router";

const ANALYTICS_NAV_GROUP_ID = "analytics_v2";

export const useShouldPreserveLocationState = (navGroupId: string) => {
  const matchRoute = useMatchRoute();
  const isOnAnalyticsRoute = Boolean(
    matchRoute({
      to: "/settings/analytics",
      fuzzy: true,
    }),
  );

  return navGroupId === ANALYTICS_NAV_GROUP_ID && isOnAnalyticsRoute;
};
